/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function ArrowDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 14.87L19.53 7.34C19.73 7.14 19.97 7.04 20.24 7.05C20.51 7.05 20.75 7.16 20.95 7.36C21.15 7.56 21.25 7.8 21.25 8.07C21.25 8.34 21.15 8.58 20.95 8.78L13.28 16.44C13.1 16.62 12.9 16.75 12.67 16.84C12.45 16.93 12.22 16.97 12 16.97C11.78 16.97 11.55 16.93 11.33 16.84C11.11 16.75 10.9 16.62 10.72 16.44L3.04001 8.75C2.84001 8.55 2.74001 8.32 2.75001 8.05C2.75001 7.78 2.86001 7.55 3.06001 7.35C3.26001 7.15 3.50001 7.05 3.77001 7.05C4.04001 7.05 4.28001 7.15 4.48001 7.35L12 14.87Z" fill="currentColor" />
    </svg>
  );
}

export default ArrowDownIcon;
